module.exports = __webpack_public_path__ + "img/guests.d4cbe947.svg";